import OrderInfo, { OrderInfoProps } from './OrderInfo';

export type { OrderInfoProps };
export default OrderInfo;
